//*
import React, { useState } from "react";
import { Link as RLink } from "react-router-dom";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import WhatshotIcon from "@mui/icons-material/Whatshot";

import { FileMetadataItem, partitionByImages } from "./fileSlice";
import styles from "./User.module.css";

let baseUrl: string;
switch (process.env.NODE_ENV) {
    case "development": {
        baseUrl = "/apidev";
        break;
    }
    case "test": {
        baseUrl = "/apidev";
        break;
    }
    case "production": {
        baseUrl = "/api";
        break;
    }
    default: {
        baseUrl = "/api";
        break;
    }
}

export default function FileMetadataList({
    data,
}: {
    data: { [key: string]: FileMetadataItem };
}) {
    const sorted = Object.values(data).sort((a, b) =>
        b.metadata.created.ts.localeCompare(a.metadata.created.ts),
    );
    return (
        <Box>
            <Card sx={{ minWidth: 275, maxWidth: 1200 }}>
                <CardContent>
                    <Typography
                        sx={{ fontSize: 14 }}
                        color="text.secondary"
                        gutterBottom
                    >
                        test.secondary and gutterBottm
                    </Typography>
                    <Typography variant="h5" component="div">
                        File By Filters
                    </Typography>
                    <Typography variant="body2">
                        length: {sorted.length}
                    </Typography>
                    <List>
                        {sorted.map((file) => {
                            const k = file.metadata.id ? file.metadata.id : "";
                            return <FileItem key={k} item={file} />;
                        })}
                    </List>
                </CardContent>
                <CardActions>
                    <Button size="small">Learn</Button>
                </CardActions>
            </Card>
        </Box>
    );
}

function FileItem({ key, item }: { key: string; item: FileMetadataItem }) {
    return (
        <ListItem key={key}>
            <ListItemText
                primary={item.name}
                secondary={
                    <React.Fragment>
                        {"extension " + item.extension + " "}
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href={
                                baseUrl +
                                "/file/download/" +
                                item.metadata.id +
                                "." +
                                item.extension
                            }
                        >
                            Download
                        </a>
                        {" - "}
                        <Link
                            component={RLink}
                            to={"/file/view/" + item.metadata.id}
                        >
                            view
                        </Link>
                        {" - "}
                        <Link
                            component={RLink}
                            to={"/page/view/" + item.page_id}
                        >
                            page ({item.page_id})
                        </Link>{" "}
                        - <br />
                        <Typography
                            component="span"
                            variant="body2"
                            sx={{ color: "text.primary", display: "inline" }}
                        >
                            {"created: " + item.metadata.created.ts}
                        </Typography>
                        <br />
                        <Typography
                            component="span"
                            variant="body2"
                            sx={{ color: "text.primary", display: "inline" }}
                        >
                            {item.metadata.modified &&
                                "modified: " + item.metadata.modified.ts}
                        </Typography>
                    </React.Fragment>
                }
            />
        </ListItem>
    );
}
